import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
  HomeOutlined,
  HomeFilled,
  TeamOutlined,
  PlusOutlined,
  FormOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { accent, neutral, gradient, shadow } from '../theme/tokens';
import { FEATURE_FLAGS } from '../featureFlags';

const tabs = [
  { key: '/teacher', icon: <HomeOutlined />, activeIcon: <HomeFilled />, label: '工作台' },
  { key: '/teacher/students', icon: <TeamOutlined />, activeIcon: <TeamOutlined />, label: '班级' },
  { key: '/teacher/record', icon: <PlusOutlined />, activeIcon: <PlusOutlined />, label: '记录', primary: true },
  // 测评入口受 FEATURE_FLAGS.ENABLE_ASSESSMENT 控制，关闭时整个 tab 不渲染
  ...(FEATURE_FLAGS.ENABLE_ASSESSMENT
    ? [{ key: '/teacher/assessments', icon: <FormOutlined />, activeIcon: <FormOutlined />, label: '测评' }]
    : []),
  { key: '/teacher/me', icon: <UserOutlined />, activeIcon: <UserOutlined />, label: '我的' },
];

const TeacherLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const activeKey =
    tabs.find(t => location.pathname === t.key)?.key ||
    tabs.find(t => location.pathname.startsWith(t.key + '/'))?.key ||
    '/teacher';

  return (
    <div style={{ minHeight: '100vh', background: neutral[50], paddingBottom: 76 }}>
      <Outlet />

      <nav
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: 'rgba(255,255,255,0.94)',
          backdropFilter: 'saturate(180%) blur(14px)',
          WebkitBackdropFilter: 'saturate(180%) blur(14px)',
          borderTop: `1px solid ${neutral[100]}`,
          display: 'flex',
          justifyContent: 'space-around',
          alignItems: 'center',
          padding: '6px 0 env(safe-area-inset-bottom, 6px)',
          zIndex: 100,
          boxShadow: '0 -1px 8px rgba(15,23,42,0.05)',
        }}
      >
        {tabs.map(tab => {
          const active = activeKey === tab.key;

          // 中间"记录"做成凸起的主操作按钮
          if (tab.primary) {
            return (
              <div
                key={tab.key}
                onClick={() => navigate(tab.key)}
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  cursor: 'pointer',
                  transform: 'translateY(-14px)',
                }}
              >
                <div
                  style={{
                    width: 52,
                    height: 52,
                    borderRadius: 18,
                    background: gradient.brand,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: 24,
                    boxShadow: shadow.brand,
                    border: `3px solid ${neutral[0]}`,
                  }}
                >
                  {tab.icon}
                </div>
                <span style={{ fontSize: 11, marginTop: 2, color: active ? accent[700] : neutral[500] }}>
                  {tab.label}
                </span>
              </div>
            );
          }

          return (
            <div
              key={tab.key}
              onClick={() => navigate(tab.key)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                padding: '4px 12px',
                minWidth: 56,
                color: active ? accent[700] : neutral[400],
                transition: 'color 0.2s',
              }}
            >
              <span style={{ fontSize: 21, lineHeight: 1 }}>{active ? tab.activeIcon : tab.icon}</span>
              <span style={{ fontSize: 11, marginTop: 3, fontWeight: active ? 600 : 400 }}>
                {tab.label}
              </span>
            </div>
          );
        })}
      </nav>
    </div>
  );
};

export default TeacherLayout;
